export const ROM_LIST__SET_ROM_LIST = 'ROM_LIST__SET_ROM_LIST';
export const ROM_LIST__SET_SEARCH_CRITERIA_VALUE = 'ROM_LIST__SET_SEARCH_CRITERIA_VALUE';
export const ROM_LIST__CLEAR_SEARCH_CRITERIA = 'ROM_LIST__CLEAR_SEARCH_CRITERIA';

export const GET_ROMS = 'API_FETCH__GET_ROMS';
